<template>
    <div class="index">
        <div class="top animated bounceInLeft">
            <h2>{{$t('lang.index_Company_Profile')}}</h2>
            <p>
                <span v-if="this.$i18n.locale === 'zh-CN' ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {{$t('lang.index_Company_Profile_text')}}
            </p>
        </div>
        <div class="connect_info">
            <div class="wei animated bounce">
                <img src="../assets/images/wx.png" alt="微信二维码">
                <p>{{$t('lang.index_Company_wx')}}</p>
            </div>
            <div class="phone_info animated bounceInRight">
                <p>{{$t('lang.foot_Phone')}}</p>
                <p>{{$t('lang.foot_Mailbox')}}</p>
                <p>{{$t('lang.foot_Address')}}</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {};
        },
        mounted() {
        },

    };
</script>

<style lang="less" scoped>
    .index {
        max-width: 1000px;
        padding: 20px;
        margin: 0 auto;
        @media screen and (max-width: 768px) {
            max-height: 90%;
            overflow: scroll;
        }

        .top {
            h2 {
                font-size: 32px;
                font-weight: 400;
                margin-top: 130px;
                margin-bottom: 60px;
                @media screen and (max-width: 768px) {
                    font-size: 28px;
                    margin-top: 20px;
                    margin-bottom: 20px;
                }
            }

            p {
                font-size: 16px;
                line-height: 32px;
                @media screen and (max-width: 768px) {
                    font-size: 14px;
                }
            }
        }

        .connect_info {
            margin-top: 200px;
            display: flex;
            display: -webkit-flex;
            align-items: center;
            @media screen and (max-width: 768px) {
                margin-top: 100px;
            }

            .wei {
                text-align: center;
                width: 107px;

                img {
                    width: 100%;
                }
            }

            .phone_info {
                margin-left: 30px;

                p {
                    font-size: 16px;
                    line-height: 36px;
                    @media screen and (max-width: 768px) {
                        font-size: 14px;
                        line-height: 32px;
                    }
                }
            }
        }
    }
</style>
